import React from 'react';
import classNames from 'classnames';

import { pushQueryParams } from 'services/history';
import withQueryParams from 'HOC/withQueryParams';
import Icon, { ICON_NAMES } from 'components/Icon';

const Category = props => {
  const { category, queryParams } = props;

  return (
    <li className="left-menu__item">
      <button
        type="button"
        className={classNames('left-menu__link', {
          'left-menu__link--active':
            (!queryParams.category_id && category.id === 'all') ||
            parseInt(queryParams.category_id) === category.id ||
            queryParams.category_id === category.id
        })}
        onClick={() => {
          pushQueryParams({ category_id: category.id });
          pushQueryParams({ page: 1 });
        }}
      >
        <span className="left-menu__text">{category.name}</span>
        <Icon name={ICON_NAMES.play} className="left-menu__icon" />
      </button>
    </li>
  );
};

export default withQueryParams(Category);
